import {useState} from 'react';

import {PdfPreviewLoader} from './PdfPreviewLoader';

type PdfPreviewProps = {bytes: Uint8Array};

export function PdfPreview(props: PdfPreviewProps) {
  const [attempt, setAttempt] = useState(0);

  return (
    <PdfPreviewLoader key={attempt} bytes={props.bytes} onRetry={() => setAttempt(attempt + 1)} />
  );
}
